import { deleteApi, post, put } from './utils'

class UserActionsApi {
  static create(data) {
    return post(`/user_actions`, {
      body: JSON.stringify({ user_action: data })
    })
  }

  static update({ userActionId, data }) {
    return put(`/user_actions/${userActionId}`, {
      body: JSON.stringify({ user_action: data })
    })
  }

  static delete(id) {
    return deleteApi(`/user_actions/${id}`)
  }
}

export default UserActionsApi
